module.exports = __webpack_public_path__ + "img/12.ad612a16.jpeg";